module.exports = __webpack_public_path__ + "static/media/29EUNOG4.768011a9.jpg";